<template>
    <div>
      <!-- 商品主数据弹层-项目名称 -->
        <el-dialog title="商品主数据" :visible.sync="dialogVisible_pic" width="90%" append-to-body
                   :close-on-click-modal="false">
            <div class="area1" style='padding: 30px;'>
                <div class="alledit" style="font-size:20px;">
                    <el-input style="width:360px;padding: 2px;box-sizing: border-box;"
                              placeholder="请输入商品编号、商品名称、规格型号、单价" prefix-icon="el-icon-search" v-model="goodslikeSearch"
                              @input="goodsforserchgroup"></el-input>
                </div>
                <div class="alledit-table">
                    <el-table ref="multipleTable" :data="tableData_pic" tooltip-effect="dark" style="width: 100%"
                             @row-dblclick='dbClickPicTable' height="250">
                        <el-table-column width="55" label="序号">
                            <template slot-scope="scope">
                                <el-radio v-model="radio_proName" :label="scope.$index + 1"
                                          @change="radiochangesp(scope.row)"></el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="goodsCode" label="商品编号"></el-table-column>
                        <el-table-column prop="goodsName" label="商品名称"></el-table-column>
                        <el-table-column prop="spec" label="规格型号"></el-table-column>
                        <el-table-column prop="unit" label="计量单位"></el-table-column>
                        <el-table-column prop="unitPrice" label="单价"></el-table-column>
                        <el-table-column prop="taxRate" label="税率"></el-table-column>
                    </el-table>
                </div>
                <!-- 分页 -->
                <el-pagination @size-change="handleSizeChangePro" @current-change="handleCurrentChangePro"
                               :page-sizes="[10, 20, 30, 40, 100]" layout="total, sizes, prev, pager, next, jumper"
                               :total="goodstotal"></el-pagination>
                <!-- 按钮 -->
                <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
					<el-button @click="closedialogVisible_pic()">取 消</el-button>
					<el-button type="primary" @click="forsurezhu">确 定</el-button>
				</span>
                <div style="height: 10px;"></div>
            </div>
        </el-dialog>

      <!--   暂时没用   -->
      <el-dialog title="红字信息表同步" :visible.sync="syncRedLetter" width="400px" append-to-body :close-on-click-modal="false">
        <div class="area1">

        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" plain @click="syncRedLetterWork()" style="width: 100px;">同步</el-button>
          <el-button type="primary" plain @click="forclosetbdialog" style="width: 100px;">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 发票关联弹出层 -->
      <el-dialog title="发票关联" :visible.sync="dialogVisible_invoice_association" width="70%" append-to-body
                 :close-on-click-modal="false">
        <taxSearch :searchdata="searchdata" :searchlist="searchlist" @submitSearch="submitSearch" labelwidth="100px">
        </taxSearch>
        <Taxtable :headData="headData" showPagination
                  :tableData="docTableData" ref="docTableData"  showSelection @sizChange="sizechange" @currentChange="currentChange"
                  :pagination="pagination">
          <template v-slot:fapzt="scope">
            <div>
              <div v-for="item in fapztlist" v-if="scope.taxval.fapzt==item.value">{{item.label}}</div>
            </div>
          </template>
          <template v-slot:faplxdm="scope">
            <div>
              <div v-for="item in fplxlist" v-if="scope.taxval.faplxdm==item.value">{{item.label}}</div>
            </div>
          </template>
          <template v-slot:kaiprq="scope">
            <div>
              {{stringtostmp(scope.taxval.kaiprq)}}
            </div>
          </template>
        </Taxtable>
        <div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
          <div></div>
          <div style="justify-content: center; display: flex;">
            <div class="backstyle" style="margin-right: 30px;margin-left: 30px; " @click="submitDocAssociation()">确认</div>
            <div class="addstyle" @click="dialogVisible_invoice_association = false">取消</div>
          </div>
        </div>
      </el-dialog>

        <el-dialog title="系统提示" :visible.sync="finishdialog" width="700px" :close-on-click-modal="false"
                   :close-on-press-escape="false" v-dialogDrag>
            <!-- <minhead :headtitle="finishtitle" :isdiag="true"></minhead> -->
            <div class="Verticalcenter"><img src="../../../assets/img/finishpic.png" width="391px" height="287px"/>
            </div>
            <div class="forfinishsuceess">提交成功,请等待税局审核</div>
            <div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
                <div></div>
                <div class="rightbuttom">
                    <div @click="finishdialog = false">确认</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="sqzdialog" width="890px" :close-on-click-modal="false" :close-on-press-escape="false"
                   v-dialogDrag>
            <div style="width: 100%;" >
                <div class="kuangall">
                    <div class="kuangall-1">
                        <span>开票日期：<span>{{yyyyMMdd(sqform1.kaiprq)}}</span></span>
                        <span>申请方经办人：<span>{{sqform1.jingbr}}</span></span>
                        <el-button type="primary" @click="addmore_list" icon="el-icon-circle-plus-outline"
                                   :disabled="this.chooseindex==1||this.isPreview!='0' ? false : true" plain>
                            增加行
                        </el-button>
                        <el-button type="primary" @click="deletemore_list" icon="el-icon-remove-outline"  :disabled="this.isPreview!='0' ? false : true" plain>
                            删除行
                        </el-button>
                    </div>
                    <div class="diagtitle">销售方信息</div>
                    <div>
                        <span class="keytext">名称</span>
                        <el-input placeholder="名称" v-model="sqform1.xiaofmc"
                                  :readonly="this.chooseindex==1 ? false : true" :disabled="this.isPreview!='0' ? false : true" style="width: 215px;"></el-input>
                        <span class="keytext" style="margin-left: 15px;">纳税人识别号</span>
                        <el-input placeholder="纳税人识别号" v-model="sqform1.xiaofsbh"
                                  :readonly="this.chooseindex==1 ? false : true" :disabled="this.isPreview!='0' ? false : true" style="width: 215px;"></el-input>
                    </div>
                    <div class="diagtitle">购货方信息</div>
                    <div>
                        <span class="keytext">名称</span>
                        <el-input placeholder="名称" v-model="sqform1.goufmc"
                                  :readonly="this.chooseindex==1 ? false : true" :disabled="this.isPreview!='0' ? false : true" style="width: 215px;"></el-input>
                        <span class="keytext" style="margin-left: 15px;">纳税人识别号</span>
                        <el-input placeholder="纳税人识别号" v-model="sqform1.goufsbh"
                                  :readonly="this.chooseindex==1 ? false : true" :disabled="this.isPreview!='0' ? false : true" style="width: 215px;"></el-input>
                    </div>
                    <div class="kuangall-1" style='margin-top: 25px;'>
                        <el-row>
                            <el-col :span="14"><span class="diagtitle ">商品信息</span></el-col>
                            <el-col :span="5" style='text-align: right;'>是否含税:</el-col>
                            <el-col :span="5" >
                                <el-switch
                                style='margin-left: 10px;'
                                v-model="hsbz"
                                @change='hsbzChange'
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                                </el-switch>
                            </el-col>
                        </el-row>
                    </div>
                    <el-table :data="diagData" :row-class-name="tableRowClassName"
                              @selection-change="diagDataSelectionChange" style="width: 100%">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="shangpmc" label="项目名称" width="200" >
                            <template slot-scope="scope">
                              <el-input placeholder="项目名称" v-model="scope.row.shangpmc"  :disabled="isPreview!='0' ? false : true" @focus='openGoods(scope.row.index)'></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="guigxh" label="规格型号" width="120">
                            <template slot-scope="scope">
                                <el-input placeholder="规格型号" v-model="scope.row.guigxh"   :disabled="isPreview!='0' ? false : true"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="danw" label="单位">
                            <template slot-scope="scope">
                                <el-input placeholder="单位" v-model="scope.row.danw"   :disabled="isPreview!='0' ? false : true"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shangpsl" label="数量" >
                            <template slot-scope="scope">
                                <el-input placeholder="数量" v-model="scope.row.shangpsl"
                                          @change="changeShul(scope.row)"   :disabled="isPreview!='0' ? false : true"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="danj" label="单价" width="120" >
                            <template slot-scope="scope">
                                <el-input placeholder="单价" v-model="scope.row.danj"
                                          @change="changeDanj(scope.row)"  @input='chooseUnitPriceChange(scope.row)' :disabled="isPreview!='0' ? false : true"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shuil" label="税率" >
                            <template slot-scope="scope">
                                <el-input placeholder="税率" v-model="scope.row.shuil"
                                          @change="changeShuil(scope.row)"  :disabled="isPreview!='0' ? false : true" ></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jine" label="金额" width="120">
                            <template slot-scope="scope">
                                <el-input placeholder="金额"  v-model="scope.row.jine"
                                          @change='changeJine(scope.row)' @input='chooseMoneyChange(scope.row)' :disabled="isPreview!='0' ? false : true" ></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column prop="shuie" label="税额" width="120">
                            <template slot-scope="scope">
                                <el-input placeholder="税额" v-model="scope.row.shuie"  @input='chooseMoneyChange(scope.row)'  :disabled="isPreview!='0' ? false : true"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="tableallstyle">合计金额：{{sqform1.hejje}} 合计税额：{{sqform1.hejse}}</div>
                    <div class="diagtitle" style="margin-top: 15px;">其它说明信息</div>
                    <div style="opacity: 0.4;">【购买方申请】对应蓝字专用发票抵扣增值税销项税额情况：已抵扣/【销售方申请】对应蓝字专用发票抵扣增值税销项税额情况：未抵扣</div>
                    <div style="margin-top: 8px;">
                        <el-input v-model="sqform1.shenqsj" placeholder="电话（非必填）：" style="width: 215px;" :disabled="this.isPreview!='0' ? false : true"></el-input>
                    </div>
                    <div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
                        <el-input style="width: 550px;" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                                  placeholder="申请理由（非必填）：" v-model="sqform1.shenqlysm" :disabled="this.isPreview!='0' ? false : true"></el-input>
                        <div style="justify-content: center; display: flex;">
                            <!-- <el-button type="primary" @click="forupload()"  v-if="this.isPreview!='0'">上传</el-button> -->
                            <!-- <el-button  @click="sqzdialog = false">返回</el-button> -->
							<div class="addstyle"style="width:60px;margin-right: 20px;"   @click="forupload()"  v-if="this.isPreview!='0'">上传</div>
							<div class="backstyle" style="width:60px" @click="sqzdialog = false">返回</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="申请" :visible.sync="sqdialog" width="700px" :close-on-click-modal="false" :close-on-press-escape="false"
                   v-dialogDrag>
            <!-- <minhead :headtitle="sqtitle" :isdiag="true"></minhead> -->
            <div style="height: 150px;">
                <div class="Centerhorizontally">
                    <div v-for="(item, index) in sqheadlist" :key="index" @click="chooseindex = index">
                        <div :style="chooseindex == index ? '' : 'opacity: 0.34'">{{ item.title }}</div>
                        <div :style="chooseindex == index ? 'background: #0080FF' : 'background: white'"
                             class="lineall"></div>
                    </div>
                </div>
                <div v-if="chooseindex == 0" class="Centerhorizontally">
                    <div>
                        <div style="width:450px;margin-top: 27px;">
                            <el-select v-model="sqform1.hansslbs">
                                <el-option label="普通征税" value="0"></el-option>
                                <el-option label="减按征税" value="1"></el-option>
                                <el-option label="差额征税" value="2"></el-option>
                            </el-select>
                        </div>
                        <div style="width:450px;margin-top: 15px;">
                            <el-input placeholder="正数发票代码" v-model="sqform1.fapdm" style="width: 215px;"></el-input>
                            <el-input placeholder="正数发票号码" v-model="sqform1.faphm"
                                      style="width: 215px;margin-left: 20px;"></el-input>
                        </div>
                    </div>
                </div>
                <div v-if="chooseindex == 1" class="Centerhorizontally">
                    <div>
                        <div style="margin-top: 53px;">
                            <el-select v-model="sqform1.hansslbs" style="margin-right: 30px;">
                                <el-option label="普通征税" value="0"></el-option>
                                <el-option label="减按征税" value="1"></el-option>
                                <el-option label="差额征税" value="2"></el-option>
                            </el-select>
                            <el-radio v-model="radiodk" label="0">已抵扣</el-radio>
                            <el-radio v-model="radiodk" label="1">未抵扣</el-radio>
                        </div>
                        <div style="width:450px;margin-top: 15px;">
                            <el-input placeholder="正数发票代码" v-model="sqform1.fapdm" style="width: 215px;"></el-input>
                            <el-input placeholder="正数发票号码" v-model="sqform1.faphm"
                                      style="width: 215px;margin-left: 20px;"></el-input>
                        </div>
                        <div style="width:450px;margin-top: 15px;">
                            <el-date-picker style="width: 215px;"
                                            v-model="sqform1.kaiprq"
                                            placeholder="开票日期"
                                            value-format="yyyyMMdd"></el-date-picker>
                        </div>
                    </div>
                </div>
            </div>
			<div style="justify-content: right; display: flex;margin-top: 60px;">
			 <!-- <el-button type="primary"  @click="fornext('sqzdialog')">下一步</el-button>
			  <el-button @click="sqdialog = false">关闭</el-button> -->
				<div class="addstyle"style="width:80px;margin-right: 20px;"  @click="fornext('sqzdialog')" >下一步</div>
				<div class="backstyle" style="width:80px" @click="sqdialog = false">关闭</div>
			</div>
        </el-dialog>
        <!-- 高级查询 -->
        <el-dialog title="高级查询" :visible.sync="cxdialog" width="900px" :close-on-click-modal="false" :close-on-press-escape="false"
                   v-dialogDrag>
            <!-- <minhead  :headtitle="cxtitle" :isdiag="true"></minhead> -->
            <div style="width: 100%;" class="horizontally">
                <el-form :model="serchform"  ref="serchform"   class="demo-ruleForm" label-width="100px"  :rules="serchformRules">
                    <div class="Centerupdown">
                        <el-form-item label="信息表编号:" prop="xinxbbh">
                            <el-input v-model="serchform.xinxbbh" style="width:215px"></el-input>
                        </el-form-item>
                        <el-form-item label="信息表申请状态:" :label-width="formLabelWidth"  prop="shenqzt">
                            <el-select v-model="serchform.shenqzt" style="width: 215px;">
                                <el-option v-for="item in selectShenqzt" :key="item.value" :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="Centerupdown">
                        <el-form-item label="正数发票代码:"  prop="yuanfpdm" >
                            <el-input v-model="serchform.yuanfpdm" style="width:215px" maxlength="12" @input="invalidSerchForm('yuanfpdm')"></el-input>
                        </el-form-item>
                        <el-form-item label="正数发票号码:" :label-width="formLabelWidth" prop="yuanfphm">
                            <el-input v-model="serchform.yuanfphm" style="width:215px" maxlength="8" @input="invalidSerchForm('yuanfphm')"></el-input>
                        </el-form-item>
                    </div>
                    <div class="Centerupdown">
                        <el-form-item label="购方名称:"  prop="goufmc">
                            <el-input v-model="serchform.goufmc" style="width:215px"></el-input>
                        </el-form-item>
                        <el-form-item label="购方税号:" :label-width="formLabelWidth" prop="goufsbh">
                            <el-input v-model="serchform.goufsbh" style="width:215px" maxlength="20" @input="invalidSerchForm('goufsbh')"></el-input>
                        </el-form-item>
                    </div>
                    <div class="Centerupdown">
                        <el-form-item label="销方名称:" prop="xiaofmc">
                            <el-input v-model="serchform.xiaofmc" style="width:215px"></el-input>
                        </el-form-item>
                        <el-form-item label="销方税号:" :label-width="formLabelWidth" prop="xiaofsbh">
                            <el-input v-model="serchform.xiaofsbh" style="width:215px" maxlength="20" @input="invalidSerchForm('xiaofsbh')"></el-input>
                        </el-form-item>
                    </div>
                    <div class="Centerupdown">
                        <el-form-item label="填开日期:" prop="tiankrq">
                            <el-date-picker
                                    v-model="serchform.tiankrq"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                            ></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="Centerupdown">
                        <el-form-item label="金     额:" prop="hejje">
                            <el-input v-model="serchform.hejje" style="width:215px" @input="invalidSerchForm('jine')"></el-input>
                        </el-form-item>

                        <el-form-item label="税      额:" :label-width="formLabelWidth" prop="hejse">
                            <el-input v-model="serchform.hejse" style="width:215px" @input="invalidSerchForm('shuie')"></el-input>
                        </el-form-item>
                    </div>
                    <div class="Centerupdown" prop="hejse">
                        <el-form-item label="抵扣标识:">
                            <el-select v-model="serchform.shenqly" style="width: 215px;">
                                <el-option label="已抵扣" value="0"></el-option>
                                <el-option label="未抵扣" value="1"></el-option>
                                <el-option label="开票有误尚未交付" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">

                <el-button type="primary" plain @click="doSerch('serchform')" style="width: 100px;">筛选</el-button>
                <el-button type="primary" plain @click="forrestsgai" style="width: 100px;">重置</el-button>
                <el-button type="primary" plain @click="forcloseshai" style="width: 100px;">关闭</el-button>
            </div>
        </el-dialog>

        <div class="areacontent">
            <div class="between-line">
                <div class="Centerupdown">
                    <!-- <el-button type="primary" plain style="width: 100px;" @click="forsqdialog">申请</el-button> -->
<!--					<div class="addstyle" @click="forsqdialog" style="width: 100px;margin-right: 10px;	"><samp>申请</samp></div>-->
                  <!-- <el-button type="primary" plain style="width: 120px;" @click="syncRedLetterWork()">同步信息单</el-button> -->
				  <div class="addstyle" @click="syncRedLetterWork()" style="width: 120px;margin-right: 10px;	"><samp>同步信息单</samp></div>
                  <!-- <el-button type="primary" plain style="width: 120px;" @click="printRedletterinfor()">打印红字信息表</el-button> -->
				  <div class="addstyle" @click="printRedletterinfor()" style="width: 120px;margin-right: 10px;	"><samp>打印红字信息表</samp></div>
                </div>
                <div class="Centerupdown">
                    <el-input
                            style="width: 300px;margin-left: 20px;margin-right: 16px;"
                            placeholder="信息表编号、发票号码"
							clearable
                            prefix-icon="el-icon-search"
                            v-model="serchval"
                            @input="forserchinput"
                    ></el-input>
                    <el-button  class="moreserch" type="primary" @click="forserch"    style="margin-right: 16px;" plain>
                        高级查询
                        <i class="el-icon-search el-icon--right"></i>
                    </el-button>
                </div>
            </div>
            <div class="areatable">
				<div class="tableh">
                <el-table :data="tableData" border @selection-change="handleSelectionChange" style="width: 100%"  ref="multipleTable" height="calc(100vh - 292px )" @sort-change="tableSortChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="xinxbbh" label="信息表编号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goufmc" label="购方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="xiaofmc" label="销方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="yuanfpdm" label="原发票代码" sortable="custom" align="center" min-width="110" ></el-table-column>
                    <el-table-column prop="yuanfphm" label="原发票号码" sortable="custom" align="center" min-width="110" ></el-table-column>
                    <el-table-column prop="hejje" label="金额" align="right" min-width="110" :formatter="formaterJine"
                                     >
                        <template slot-scope="scope">
                            <span >{{toThousands(Amountformat(scope.row.hejje))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="hejse" label="税额" align="right" min-width="110" :formatter="formaterShuie"
                                    >
                        <template slot-scope="scope">
                            <span >{{toThousands(Amountformat(scope.row.hejse))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tiankrq" label="填开日期"align="left" min-width="160px" show-overflow-tooltip ></el-table-column>
                    <el-table-column prop="shenqly" label="抵扣标识" align="center" min-width="100"
                                     :formatter="formaterShenqly"></el-table-column>
                    <el-table-column prop="zhuangtms" label="信息表描述" align="left" min-width="160px" show-overflow-tooltip ></el-table-column>
                    <el-table-column prop="shenqzt" label="信息表申请状态" :formatter="formaterShenqzt"
                                     align="center" min-width="120"  ></el-table-column>
                  <el-table-column prop="kaipzddm" label="税盘编号"
                                   align="center" min-width="120" ></el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="160" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small"  @click="preview(scope.$index, scope.row)">预览</el-button>
                            <el-button type="text" size="small" :disabled="scope.row.shenqzt == 3" @click="backOut(scope.$index, scope.row)">撤销</el-button>
                          <el-button type="text" size="small" :disabled="(scope.row.shenqly == 0 && scope.row.shenqzt == 5) ? false : true" @click="openDocdialog(scope.$index, scope.row)">发票关联
                          </el-button>
                        </template>
                    </el-table-column>
                </el-table>
				</div>
                <div class="lastend">
                    <div>
                        当前已勾选
                        <span>{{selectCount}}</span>
                        条
                    </div>
                    <div>
                        合计金额
                        <span>{{toThousands(Amountformat(selectJine))}}</span>
                    </div>
                    <div>
                        合计税额
                        <span>{{toThousands(Amountformat(selectShuie))}}</span>
                    </div>
                </div>
                <div class="buttompage">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[10, 20, 100, 500]"
                            :page-size="pagenum"
                            :key="elementui_page_component_key"
                            :current-page="currentpage"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalcount"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <el-dialog   :visible.sync="tbxxddialog" title="信息表同步" width="700px" :close-on-click-modal="false" v-dialogDrag>
            <div class="Centerhorizontally" style="margin-bottom: 25px;">
                <div v-for="(item, index) in tbxxdheadlist" :key="index" @click="changeindex(index)" class="choosediv">
                    <div :style="tbxxdchooseheadindex == index ? '' : 'opacity: 0.34'">{{ item.title }}</div>
                    <div :style="tbxxdchooseheadindex == index ? 'background: #0080FF' : 'background: white'" class="lineall"></div>
                </div>
            </div>
            <div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally" v-if="tbxxdchooseheadindex == 0">
                <div style="width: 100%;" class="horizontally">
                    <el-form :model="tbxxdform_0"  label-width="100px" class="demo-ruleForm" style="margin-right: 100px;">
                        <div class="Centerupdown">
                            <el-form-item label="税盘编号:" :label-width="formLabelWidth">
                                <el-select v-model="tbxxdform_0.jqbh" style="width: 215px;">
                                    <el-option v-for="item in kpjList" :key="item.kaipjbh"
                                               :label="item.kaipjmc" :value="item.kaipjbh"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="Centerupdown">
                            <el-form-item label="发票类型:" :label-width="formLabelWidth" >
                                <el-select v-model="tbxxdform_0.fplxdm"  style="width: 215px;">
                                    <el-option label="全部" value="028,004"></el-option>
                                    <el-option label="电子专票" value="028"></el-option>
                                    <el-option label="纸质专票" value="004"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="Centerupdown">
                            <el-form-item label="红字信息表编号:" :label-width="formLabelWidth" >
                                <el-input v-model="tbxxdform_0.xxbbh" style="width:215px" ></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
            <div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally" v-if="tbxxdchooseheadindex == 1">
                <div style="width: 100%;" class="horizontally">
                    <el-form :model="tbxxdform_1"  label-width="100px" class="demo-ruleForm" style="margin-right: 100px;">
                        <div class="Centerupdown">
                            <el-form-item label="税盘编号:" :label-width="formLabelWidth">
                                <el-select v-model="tbxxdform_1.jqbh" style="width: 215px;">
                                    <el-option v-for="item in kpjList" :key="item.kaipjbh"
                                               :label="item.kaipjmc" :value="item.kaipjbh"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="Centerupdown">
                            <el-form-item label="发票类型:" :label-width="formLabelWidth">
                                <el-select v-model="tbxxdform_1.fplxdm"  style="width: 215px;">
                                    <el-option label="全部" value="028,004"></el-option>
                                    <el-option label="电子专票" value="028"></el-option>
                                    <el-option label="纸质专票" value="004"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="Centerupdown">
                            <el-form-item label="信息表申请时间:" :label-width="formLabelWidth" >
                                <el-date-picker
                                    v-model="tbxxdform_1.tkrq"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyyMMdd"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
            <div slot="footer" style="justify-content: right; display: flex;">
				<div class="addstyle"style="width:100px;margin-right: 20px;"  @click="submitSktb"  >同步</div>
				<div class="addstyle"style="width:100px;margin-right: 20px;"  @click="resetSktb"  >重置</div>
				<div class="addstyle"style="width:100px;margin-right: 20px;"  @click="tbxxdclose"  >关闭</div>
                <!-- <el-button type="primary" plain  @click="submitSktb"  style="width: 100px;">同步</el-button> -->
                <!-- <el-button type="primary" plain  @click="resetSktb"  style="width: 100px;">重置</el-button> -->
                <!-- <el-button type="primary" plain @click="tbxxdclose"  style="width: 100px;">关闭</el-button> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Vue from "vue";
	var _this
    export default {
        components: {},
        data() {
            return {
                radiodk: '1',
                formLabelWidth: '150px',
                cxdialog: false,
                sqdialog: false,
                sqzdialog: false,
                finishdialog: false,
                syncRedLetter: false,

                /* 商品主数据相关 */
                dialogVisible_pic: false, //商品主数据弹框
                goodspage: 1, //第几页
                goodspagenum: 10, //每页条数
                goodssearch: {
                  companyCode: '',
                  goodsCode: '',
                  goodsName: '',
                  taxRate: '',
                  unitPrice: '',
                  taxCode: '',
                  isEffective: '1' //是否有效 1:有效
                },
                total: '',
                chooseallsp: '',
                goodslikeSearch: '',
                tableData_pic: [],
                radio_proName: 0,
                goodstotal: '', //总条数
                /* 商品主数据相关 */

                /* 开具弹框 */
                page: 1,
                pagenum: 10,
                totalcount: 0,
                serchform: {},
                serchformRules: {
                    hejse: [ { validator: this.validateHejjeAndHejse, trigger: 'blur' }],
                    hejje: [ { validator: this.validateHejjeAndHejse, trigger: 'blur' }],
                    goufsbh:[ { validator: this.validateCustomersbh, trigger: 'blur' }],
                    xiaofsbh:[ { validator: this.validateCustomersbh, trigger: 'blur' }],
                    yuanfpdm:[ { validator: this.validateFapdm, trigger: 'blur' }],
                    yuanfphm:[ { validator: this.validateFaphm, trigger: 'blur' }]
                },
                sqheadlist: [
                    {
                        title: '销售方申请'
                    },
                    {
                        title: '购买方申请'
                    }
                ],
                sqform1: {
                    tiankrq: "",
                    jingbr: ""
                },
                tableData: [],
                diagData: [
                    {
                        shangpmc:"",
                        guigxh: '',
                        shangpsl: '',
                        danj: '0.00',
                        jine:'0.00',
                        shuil:'',
                        shuie: '0.00'
                    },
                ],
                headtitle: ['发票管理', '红字信息表管理'],
                serchval: '',
                finishtitle: ['系统提示'],
                cxtitle: ['高级查询'],
                sqtitle: ['申请'],
                chooseindex: 0,
                selectCount: 0,
                selectJine: 0.00,
                selectShuie: 0.00,
                deleteindexsqd: '',
                selectionItemIndexes: [],
                selectShenqzt: [],
				tableHeight:"",
                isPreview:"",
                currentpage: 1,
                elementui_page_component_key: '',
                stateall:{},
                priceallchooseindex: '',
                hsbz:false,
                sort:"desc",
                order:"id",
                selectRows:[],

              searchdata:{
                gouhfmc:"",
                gouhfsbh:"",
                fapdm:"",
                faphm:"",
                kaiprq:[],
                hejje:"",
                hejse:""
              },
              searchlist:[
                {
                  prop: "gouhfmc",
                  label: '购货方名称',
                  type: "input",
                  disabled:true
                },
                {
                  prop: "gouhfsbh",
                  label: '购货方识别号',
                  type: "input",
                  disabled:true
                },
                {
                  prop: "fapdm",
                  label: '发票代码',
                  type: "input"
                },
                {
                  prop: "faphm",
                  label: '发票号码',
                  type: "input"
                },
                {
                  prop: "kaiprq",
                  label: '开票日期',
                  type: "date",
                  valueformat:"yyyy-MM-dd"
                },
                {
                  prop: "hejje",
                  label: '金额',
                  type: "input"
                },
                {
                  prop: "hejse",
                  label: '税额',
                  type: "input"
                },
              ],
              pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
              },
              headData: [
                {
                  title: "发票状态",
                  prop: "fapzt",
                  width: "100",
                  issort: true,
                  custom: true
                },
                {
                  title: "发票代码",
                  prop: "fapdm",
                  width: "200",
                  issort: true
                },
                {
                  title: "发票号码",
                  prop: "faphm",
                  width: "200",
                  issort: true
                },
                {
                  title: "发票类型",
                  prop: "faplxdm",
                  width: "200",
                  issort: true,
                  custom: true
                },
                {
                  title: "发票状态",
                  prop: "fapzt",
                  width: "100",
                  issort: true,
                  custom: true
                },
                {
                  title: "金额",
                  prop: "hejje",
                  width: "200",
                  issort: true
                },
                {
                  title: "税额",
                  prop: "hejse",
                  width: "200",
                  issort: true
                },
                {
                  title: "价税合计",
                  prop: "jiashj",
                  width: "200",
                  issort: true
                },
                {
                  title: "开票日期",
                  prop: "kaiprq",
                  width: "200",
                  issort: true,
                  custom: true
                }
              ],
              docTableData:[],
              dialogVisible_invoice_association:false,
              select_invoice_association_row:{},
                tbxxddialog:false,
                tbxxdbtitle:"信息表同步",
                tbxxdheadlist:[
                    {
                        title: '信息表编号查询'
                    },
                    {
                        title: '时间段查询'
                    }
                ],
                tbxxdchooseheadindex:0,
                tbxxdform_0:{
                    jqbh:"",
                    fplxdm:"",
                    xxbbh:"",
                },
                tbxxdform_1:{
                    jqbh:"",
                    fplxdm:"",
                    tkrq:[],
                },
                kpjList:[],
            };
        },
        created() {
			_this=this
            this.getRedLetterInfoList();
            this.initSelectShenqzt();
            this.loadKpjList();
        },
		mounted() {
			 this.repairtable();
		},
        methods: {
            loadKpjList() {
                this.$https.fetchPost('doc/getKaipjList').then(res => {
                    if (res.data.success){
                        this.kpjList = JSON.parse(res.data.obj);
                    }
                });
            },
            changeindex(index){
                // Object.keys(this.sktbform).map(key => (this.sktbform[key] = ''));
                this.tbxxdchooseheadindex=index;
            },
            repairtable(){
                this.$nextTick(() => {
                    this.tableHeight = this.diagheightzhengshutiankai();
                    setTimeout(() => {
                        this.$refs.multipleTable.doLayout();
                    }, 300);
                    window.onresize = () => {
                        this.tableHeight = this.diagheightzhengshutiankai();
                        setTimeout(() => {
                            this.$refs.multipleTable.doLayout();
                        }, 300);
                    };
                });
            },
            forupload() {
                if (this.chooseindex === 0) {   //  销售方申请
                    this.sqform1.shenqfs = "0";
                    this.sqform1.shenqly = "2"; //  申请来源：2-销售方申请
                } else {    //  购买方申请
                    this.sqform1.shenqfs = "2";
                    this.sqform1.shenqly = this.radiodk;
                }
                let diagDataSubmit = [];
                this.diagData.forEach(item => {
                    let row = Object.assign({},item);
                    row.shul = item.shangpsl;
                    row.shuil = Number.parseFloat(item.shuil.replace("%","")) / 100;
                    diagDataSubmit.push(row);
                });
                this.sqform1.hansbz = this.hsbz == true ? "1" : "0";
                let jshj  = 0;
                if (this.hsbz) {
                    jshj = Number.parseFloat(this.sqform1.hejje) + Number.parseFloat(this.sqform1.hejse);
                } else {
                    jshj = this.sqform1.hejje;
                }
                this.sqform1.jiashj = jshj;
                let params = {
                    faphm: this.sqform1.faphm,
                    fapdm: this.sqform1.fapdm,
                    kaiprq: this.sqform1.kaiprq,
                    redLetterInfo: this.sqform1,
                    details: diagDataSubmit,
                    kaipzddm : this.sqform1.kaipzddm
                };
                console.log(params);
                this.$https.fetchPost('/redLetter/addRedLetterInfo', params).then(res => {
                    if (res.data.success) {
                        this.sqzdialog = false;
                        this.finishdialog = true;
                        this.getRedLetterInfoList();
                    }
                });
            },
            fornext(e) {
                this.isPreview="1";
                if (this.chooseindex != 1 || this.radiodk != '0') {
                    if ((this.sqform1.faphm === "" || this.sqform1.faphm === undefined
                        || this.sqform1.fapdm === "" || this.sqform1.fapdm === undefined
                        || this.sqform1.hansslbs === undefined || this.sqform1.hansslbs === "")) {
                        this.$message({
                            type: 'error',
                            message: this.$tolertJSON['008-1']
                        });
                        return;
                    }
                }
                if (this.chooseindex == 1) {
                    let userobj=JSON.parse(localStorage.getItem("useropj"));
                    this.sqform1.goufsbh = userobj.currCompany.taxNumber;
                    this.sqform1.goufmc = userobj.currCompany.name;
                } else {
                    this.sqform1.goufsbh = "";
                    this.sqform1.goufmc = "";
                }
                let params = {
                    faphm: this.sqform1.faphm,
                    fapdm: this.sqform1.fapdm
                };
                this.$https.fetchPost('/redLetter/getRealDocInfo', params).then(res => {
                    if (res.data.success) {
                        if (res.data.obj != null) {
                            this.sqform1 = res.data.obj;
                            this.sqform1.tiankrq = new Date().toLocaleDateString();
                            var userobj=JSON.parse(localStorage.getItem("useropj"));
                            this.sqform1.jingbr = userobj.userName;
                            let details = res.data.obj.realDocDetailList;
                            if(details!=undefined && details.length>0){
                                for (let i = 0; i < details.length; i++) {
                                    if (details[i].shangpsl) {
                                        details[i].shangpsl = -details[i].shangpsl;
                                    }
                                    details[i].shuil = Number.parseFloat(details[i].shuil) * 100 + "%",
                                    details[i].jine = -details[i].jine;
                                    details[i].shuie = -details[i].shuie;
                                    details[i].shangpsl=details[i].shangpsl;
                                    details[i].lingslbz=details[i].lingslbz;
                                }
                            }
                            this.sqform1.hejje = -this.sqform1.hejje;
                            this.sqform1.hejse = -this.sqform1.hejse;
                            this.diagData = details;
                            this.sqdialog = false;
                            this.sqzdialog = true;
                        } else {
                            this.diagData = [{
                                shangpmc:"",
                                guigxh: '',
                                shangpsl: '',
                                danj: '',
                                jine:'',
                                shuil:'',
                                shuie: ''}];
                            this.sqdialog = false;
                            this.sqzdialog = true;
                        }

                    } else {
                        if (this.chooseindex === 0) {
                            this.$message({
                                type: 'error',
                                message: this.$tolertJSON[res.data.code]
                            });
                        } else {
                            this.sqform1.hejje = "0.00";
                            this.sqform1.hejse = "0.00";
                            this.diagData = [{
                                shangpmc:"",
                                guigxh: '',
                                shangpsl: '',
                                danj: '',
                                jine:'',
                                shuil:'',
                                shuie: ''}];
                            this.sqdialog = false;
                            this.sqzdialog = true;
                        }
                    }
                });
            },
            forsqdialog() {
                this.sqdialog = true;
            },
            /* 筛选 */
            forserchshai() {
                this.cxdialog = false;
            },
            forcloseshai() {
                this.cxdialog = false;
            },
			forserchinput(){
                 this.elementui_page_component_key++;
                 this.currentpage = 1;
				 Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
				 this.getRedLetterInfoList()
			},
            /* 重置 */
            forrestsgai() {
                Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
            },
            handleSizeChange(val) {
                this.pagenum = val;
                this.getRedLetterInfoList();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getRedLetterInfoList();
            },
            handleSelectionChange(e) {
                this.selectRows = e;
                this.selectCount = 0;
                this.selectJine = 0;
                this.selectShuie = 0;
                let hejje = 0;
                let hejse = 0;
                let count = 0;
                e.forEach((item, index) => {
                    count++;
                    hejje=this.printFn(parseFloat(hejje)+parseFloat(item.hejje==""?"0":item.hejje));
                    hejse= this.printFn(parseFloat(hejse)+parseFloat(item.hejse==""?"0":item.hejse));
                });
                this.selectCount = count;
                this.selectJine = hejje;
                this.selectShuie = hejse;
            },
            tableSortChange(column, prop, order){
              this.order=column.prop;
              if(column.order){
                this.sort=column.order.replace("ending","");
              }else{
                this.sort="desc";
                this.order="id";
              }
              this.getRedLetterInfoList();
            },
            /* 高级查询弹框	 */
            forserch() {
                this.cxdialog = true;
            }, getRedLetterInfoList() {

                if (this.serchform.tiankrq && this.serchform.tiankrq !== "") {
                    let dateArray = this.serchform.tiankrq;
                    this.serchform.tiankrqStart = dateArray[0];
                    this.serchform.tiankrqEnd = dateArray[1];
                    this.serchform.tiankrq = dateArray[0] + ',' + dateArray[1];
                }
                let params = {
                    likeSearch: this.serchval,
                    search: this.serchform,
                    page: this.page,
                    limit: this.pagenum,
                    sort: this.sort,
                    order: this.order
                };
                this.$https.fetchPost('/redLetter/getRedLetterInfoList', params).then(res => {
                  res.data.data.redLetterInvoiceDetails
                  for (let j = 0; j < res.data.data.length; j++) {
                    for (let i = 0; i < res.data.data[j].redLetterInvoiceDetails.length; i++) {
                      if (res.data.data[j].redLetterInvoiceDetails[i].shangpsl) {
                        details[i].shangpsl = -details[i].shangpsl;
                      }
                      res.data.data[j].redLetterInvoiceDetails[i].jine = -res.data.data[j].redLetterInvoiceDetails[i].jine;
                      res.data.data[j].redLetterInvoiceDetails[i].shuie = -res.data.data[j].redLetterInvoiceDetails[i].shuie;
                      res.data.data[j].redLetterInvoiceDetails[i].shangpsl=res.data.data[j].redLetterInvoiceDetails[i].shul;
                      res.data.data[j].redLetterInvoiceDetails[i].lingslbz=res.data.data[j].redLetterInvoiceDetails[i].lingslbz;
                    }
                  }
                  console.log(res.data.data);
                  this.tableData = res.data.data;
                  this.totalcount = res.data.count;
                  Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
                  this.cxdialog = false;
                  console.log("****==>" + JSON.stringify(res.data.data));
                })
            }, backOut(index, row) {
                let parms = {
                    redLetterInfoPojo: {redLetterId: row.id},
                    kaipzddm : row.kaipzddm
                };
                this.$https.fetchPost('/redLetter/backOutRedLetterInfo', parms).then(res => {
                    if (res.data.success) {
                        this.getRedLetterInfoList();
                    }
                });
            },preview(index, row){
                this.isPreview="0";
                this.sqform1=row;
                this.diagData = row.redLetterInvoiceDetails;
                this.diagData.forEach(item => {
                    if (item.shangpbmjc != null && item.shangpbmjc != "") {
                        let jc = "*" +item.shangpbmjc + "*";
                        if (item.shangpmc.indexOf(jc) == -1) {
                            item.shangpmc = "*" +item.shangpbmjc + "*" + item.shangpmc;
                        }
                    }
                    item.jine = Number.parseFloat(item.jine) > 0 ? Number.parseFloat(item.jine) * -1 : item.jine;

                    item.shuie = Number.parseFloat(item.shuie) > 0 ? Number.parseFloat(item.shuie) * -1 : item.shuie;
                })
                console.log(this.sqform1);
                console.log(this.diagData);
                this.sqform1.kaiprq=row.yuanKprq;
                this.sqdialog = false;
                this.sqzdialog = true;
                console.log(this.isPreview)
            }, formaterShenqly(row, column, cellValue, index) {
                /**
                 * 0、1、2
                 * 购方申请：
                 * 0：已抵扣
                 * 1：（1 对应以下四个理由中的其中 一个）
                 * 未抵扣无法认证；
                 * 未抵扣税号认证不符；
                 * 未抵扣代码号码认证不符；
                 * 货物不属于增值税项目范围
                 * 销方申请：
                 * 2：（2 对应以下两个理由中的其中 一个）
                 * 开票有误购买方拒收；
                 * 开票有误等原因尚未交付**/
                let result = row.shenqly;
                switch (row.shenqly) {
                    case "0":
                        result = "已抵扣";
                        break;
                    case "1":
                        result = "未抵扣";
                        break;
                    case "2":
                        result = "销方申请";
                        break;
                }
                return result;
            }, formaterJine(row) {
                let hejje = row.hejje;
                return hejje.toFixed(2);
            }, formaterShuie(row) {
                let hejse = row.hejse;
                return hejse.toFixed(2);
            }, formaterShenqzt(row) {
                /**      0:已申请
                 1:已下载
                 2:已开单据
                 3：已开具
                 4：已撤销
                 5：已审核
                 **/
                let result = row.shenqzt;
                switch (row.shenqzt) {
                    case "0":
                        result = "已申请";
                        break;
                    case "1":
                        result = "已下载";
                        break;
                    case "2":
                        result = "已开单据";
                        break;
                    case "3":
                        result = "已开具";
                        break;
                    case "4":
                        result = "已撤销";
                        break;
                    case "5":
                        result = "已审核";
                        break;
                  case "6":
                    result = "审核失败";
                    break;
                }
                return result;
            }
            ,// 增加行--清单
            addmore_list() {
                this.diagData.push({
                    shangpmc:"",
                    guigxh: '',
                    shangpsl: '',
                    danj: '',
                    jine:'',
                    shuil:'',
                    shuie: ''});
            },
            // 删除行--清单
            deletemore_list(index, row) {
                if (this.selectionItemIndexes.length === 0) {
                    this.$message({
                        type: 'info',
                        message: '请选择要删除的条目'
                    });
                    this.selectionItemIndexes = [];
                    return false;
                }
                this.diagData = this.diagData.filter((item, index) => {
                    let arrlist = this.selectionItemIndexes;
                    return !arrlist.includes(index);
                });
                this.totoalamount();

            },/* 	计算合计 */
            totoalamount() {
                this.sqform1.hejje = 0;
                this.sqform1.hejse = 0;
                let hejje = 0.00;
                let hejse = 0.00;
                this.diagData.forEach(item => {
                    console.log(item);
                    if(item.jine==""||item.jine==undefined ||item.jine=='NaN'){
                      item.jine=0;
                    }
                    if(item.shuie==""||item.shuie==undefined ||item.shuie=='NaN'){
                      item.shuie=0;
                    }
                    if (this.hsbz) {
                        let shuil = Number(item.shuil.replaceAll("%","")) / 100;
                        hejje = hejje + this.numdiv(item.jine, 1 + shuil);
                    } else {
                        hejje = hejje + Number(item.jine);
                    }

                    hejse = hejse + Number(item.shuie) ;
                });
                // if (this.hsbz) {
                //     hejje = hejje - hejse;
                // }
                this.sqform1.hejje = hejje.toFixed(2);
                this.sqform1.hejse = hejse.toFixed(2);

                if(this.sqform1.hejje.toString().indexOf(".") == -1) {
                    this.sqform1.hejje = this.sqform1.hejje + ".00";
                }

                if(this.sqform1.hejse.toString().indexOf(".") == -1) {
                    this.sqform1.hejse = this.sqform1.hejse + ".00";
                }
            }, diagDataSelectionChange(rows) {
                this.selectionItemIndexes = [];
                rows.forEach(item => {
                    this.selectionItemIndexes.push(item.index);
                });
            }, tableRowClassName(row, index) {
                row.row.index = row.rowIndex;
            },
            initSelectShenqzt() {
                this.$https.fetchPost('config/getSelectByKey', "REDLETTER_SHENQZT").then(res => {
                    this.selectShenqzt = this.setSelectKey(JSON.parse(res.data.obj));
                });
            },
            /* 所有商品主数据列表数据的改变 */
            handleSizeChangePro(val) {
                this.goodspagenum = val;
                this.getGoodsList();
            },
            handleCurrentChangePro(val) {
                this.goodspage = val;
                this.getGoodsList();
            },
            hsbzChange(){
                if (this.hsbz) {
                    this.diagData.forEach(item => {
                        item.jine = (Number(item.jine) + Number(item.shuie)).toFixed(2);
                        if (Number(item.shangpsl) != 0) {
                            item.danj = (Number(item.jine) / Number(item.shangpsl).toFixed(8));
                        } else {
                            item.danj = 0;
                        }
                    })
                    this.totoalamount();
                } else {
                    this.diagData.forEach(item => {
                        item.jine = (Number(item.jine) - Number(item.shuie)).toFixed(2);
                        if (Number(item.shangpsl) != 0) {
                            item.danj = (Number(item.jine) / Number(item.shangpsl).toFixed(8));
                        } else {
                            item.danj = 0;
                        }
                    })
                    this.totoalamount();
                }

            },
            changeShul(item) {

                if (this.emptyandnull(item.shangpsl)) {
                    return false
                }
                if (item.shangpsl > 0) {
                    item.shangpsl = Number(item.shangpsl) * -1;
                }
                this.calculateJine(item);
                this.changeShuil(item);
                this.totoalamount();
                this.updateTable();
                this.$forceUpdate();
            },
          chooseMoneyChange(item){
            let arr = item.jine.split(".");
            if (arr.length == 2 && arr[1].length > 2) {
              item.jine = arr[0] + "."  + arr[1].substring(0,2);
            }
            this.$forceUpdate();
          },
          chooseUnitPriceChange(item){
            let arr = item.danj.split(".");
            if (arr.length == 2 && arr[1].length > 10) {
              item.danj = arr[0] + "."  + arr[1].substring(0,10);
            }
            this.$forceUpdate();
          },
            changeDanj(item) {
                if (this.emptyandnull(item.danj)) {
                    item.jine = "";
                    return;
                }
                if (item.danj < 0) {
                    item.danj = Number(item.danj) * -1;
                }
                this.calculateJine(item);
                this.changeShuil(item);
                this.totoalamount();
                this.updateTable();
                this.$forceUpdate();
            },
            changeJine(item) {
                if (this.emptyandnull(item.jine)) {
                    return false
                }
                if (item.jine > 0) {
                    item.jine = Number(item.jine) * -1;
                }
                item.jine = item.jine.toFixed(2);
                this.calculateDanJ(item);
                this.changeShuil(item);
                this.totoalamount();
                this.updateTable();
                this.$forceUpdate();
            },
            changeShuil(item) {
                if (this.emptyandnull(item.shuil)) {
                    return false
                }
                if (item.shuil.indexOf("%") == -1) {
                    item.shuil = Number(item.shuil) * 100 + "%";
                }
                this.calculateShuie(item);
                this.totoalamount();
                this.updateTable();
                this.$forceUpdate();
            },
            calculateJine(item) {
                item.jine = this.multiply(item.shangpsl, item.danj).toFixed(2);
                let shuil = Number(item.shuil.replaceAll("%","")) / 100;
                if (this.hsbz) {
                    let amountExcludingTax = this.numdiv(item.jine, 1 + shuil).toFixed(2);
                    item.shuie = this.multiply(amountExcludingTax, shuil).toFixed(2);
                } else {
                    item.shuie = this.multiply(item.jine, shuil).toFixed(2);
                }
                item = JSON.parse(JSON.stringify(item));
                this.retainDecimal(item);
            },
            calculateDanJ(item) {
                let sl = 1;
                if (item.shangpsl != null && item.shangpsl != "") {
                    sl = item.shangpsl;
                }
                let danj = Number(Number(item.jine) / Number(sl).toFixed(8));

                if (danj.toString().indexOf(".") != -1) {
                    let arr = danj.toString().split(".");
                    if (arr[1] > 15) {
                        item.danj = danj.toFixed(15);
                    } else {
                        item.danj = danj
                    }
                } else {
                    item.danj = danj.toFixed(2);
                }
                let shuil = Number(item.shuil.replaceAll("%","")) / 100;
                if (this.hsbz) {
                    let amountExcludingTax = this.numdiv(item.jine, 1 + shuil).toFixed(2);
                    item.shuie = this.multiply(amountExcludingTax, shuil).toFixed(2);
                } else {
                    item.shuie = this.multiply(item.jine, shuil).toFixed(2);
                }
                this.retainDecimal(item);
            },
            calculateShuie(item) {
                let shuil = Number(item.shuil.replaceAll("%","")) / 100;
                if (this.hsbz) {
                    let amountExcludingTax = this.numdiv(item.jine, 1 + shuil).toFixed(2);
                    item.shuie = this.multiply(amountExcludingTax, shuil).toFixed(2);
                } else {
                    item.shuie = this.multiply(item.jine, shuil).toFixed(2);
                }

                this.retainDecimal(item);
            },

            retainDecimal(item) {
                //金额、税额、合计金额、合计税额保留2位小数，单价保留8位，税率使用%表示
                // item.jine = item.jine.toFixed(2);
                console.log(item);
                item.shuie = item.shuie;
                if(item.shuie.toString().indexOf(".") == -1) {
                    item.shuie = item.shuie + ".00";
                }
                if(item.jine.toString().indexOf(".") == -1) {
                    item.jine = item.jine + ".00";
                }


                // item.danj = item.danj.toFixed(8);

                // item.shuil = item.shuil * 100 + "%"
            },

            updateTable() {
                this.diagData.push({});
                this.diagData.pop({});
            }, invalidSerchForm(type) {
                switch (type) {
                    case "yuanfpdm":
                        this.serchform.yuanfpdm = this.serchform.yuanfpdm.replace(/[^\d]/g, '');
                        break;
                    case "yuanfphm":
                        this.serchform.yuanfphm = this.serchform.yuanfphm.replace(/[^\d]/g, '');
                        break;
                    case "jine":
                        this.serchform.hejje = this.serchform.hejje.replace(/[^-\d.]/g, '');
                        break;
                    case "shuie":
                        this.serchform.hejse = this.serchform.hejse.replace(/[^-\d.]/g, '');
                        break;
                    case "goufsbh":
                        this.serchform.goufsbh = this.serchform.goufsbh.replace(/[^\da-zA-Z]/g, '');
                        break;
                    case "xiaofsbh":
                        this.serchform.xiaofsbh = this.serchform.xiaofsbh.replace(/[^\da-zA-Z]/g, '');
                        break;
                }
            }, doSerch(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
							this.serchval=""
                        _this.getRedLetterInfoList();
                    }else
                    {
                        return false
                    }
                });
            },
          /* --商品主数据弹出*/
          openGoods(index) {
            this.priceallchooseindex = index;
            this.radio_proName = 0;
            this.goodslikeSearch = '';
            this.dialogVisible_pic = true;
            this.getGoodsList();
          },
            /* 获取商品列表数据 */
            getGoodsList() {
                let params = {
                    page: this.goodspage,
                    limit: this.goodspagenum,
                    search: this.goodssearch,
                    likeSearch: this.goodslikeSearch,
                    sort: 'asc',
                    order: 'goodsCode'
                };
                this.$https.fetchPost('/master/getInvoiceGoodsList', params).then(res => {
                    this.goodstotal = res.data.count;
                    this.tableData_pic = res.data.data;
                });
            },
          /* 所有商品主数据列表数据搜索 */
          goodsforserchgroup() {
            this.getGoodsList();
          },
          /* 发票选择主数据 */
          radiochangesp(val) {
            this.chooseallsp = val;
          },
          /* 关闭商品主数据弹框 */
          closedialogVisible_pic() {
            this.dialogVisible_pic = false;
          },
          /* 	确认选择商品主数据 */
            dbClickPicTable(row, column, event){
                this.radiochangesp(row);
                this.forsurezhu();
            },
          forsurezhu() {
              this.chooseallsp.shangpmc = this.chooseallsp.goodsName;
              this.chooseallsp.shuisbm = this.chooseallsp.taxCode;
              this.chooseallsp.shuil = this.chooseallsp.taxRate;
              this.chooseallsp.guigxh = this.chooseallsp.spec;
              this.chooseallsp.danw = this.chooseallsp.unit;
              this.chooseallsp.danj = this.chooseallsp.unitPrice;
              this.diagData[this.priceallchooseindex] = {
                  shangpmc:this.chooseallsp.shangpmc,
                  guigxh: this.chooseallsp.guigxh,
                  shangpsl: '',
                  jine:'',
                  danj: this.chooseallsp.danj,
                  shuil: Number.parseFloat(this.chooseallsp.shuil) * 100 + "%",
                  shuisbm: this.chooseallsp.taxCode,
                  shuie: ''};
              let data = JSON.parse(JSON.stringify(this.diagData)) ;
              this.diagData= data;
              // this.$set(this.diagData, this.priceallchooseindex, this.chooseallsp);
              this.dialogVisible_pic = false;
          },
          /* 下载同步相关 */
          syncRedLetterWork() {
            // this.$https.fetchPost('/redLetter/syncRedLetter', "{}").then(res => {
            //   if (res.data.success) {
            //     this.getRedLetterInfoList();
            //   }
            // });
              this.tbxxddialog = true;
          },
            printRedletterinfor(){
                if (this.selectRows.length == 0) {
                    this.$message.error("请选择要打印的数据！");
                    return;
                }

                let data = [];
                this.selectRows.forEach(item => {
                    let details = [];
                    if (item.shangpbmjc != null && item.shangpbmjc != "") {
                        item.shangpmc = "*" +item.shangpbmjc + "*" + item.shangpmc;
                    }
                    item.redLetterInvoiceDetails.forEach(detail => {
                        let spmc = detail.shangpmc;
                        if (detail.shangpbmjc != null && detail.shangpbmjc != ""){
                            let jc = "*" +detail.shangpbmjc + "*";
                            if (detail.shangpmc.indexOf(jc) == -1) {
                                spmc = jc + spmc;
                            }
                        }

                        let detailData = {
                            spmc: detail.shangpbmjc!=null && detail.shangpbmjc != "" ? spmc : detail.shangpmc,
                            ggxh: detail.guigxh,
                            jldw: detail.danw,
                            sl: detail.shangpsl,
                            dj: detail.danj,
                            je: Number.parseFloat(detail.jine) > 0 ? Number.parseFloat(detail.jine) * -1 : detail.jine,
                            slv: Number.parseFloat(detail.shuil) * 100,
                            se: Number.parseFloat(detail.shuie) > 0 ? Number.parseFloat(detail.shuie) * -1 : detail.shuie
                        }
                        details.push(detailData);
                    })
                  let isgffp;
                  let hzxxbsqf;
                  let reqmemo;
                  let yfpdm = item.yuanfpdm;
                  let yfphm = item.yuanfphm;
                  if(item.shenqly==='0'){
                    isgffp=1;
                    hzxxbsqf=1;
                    reqmemo="Y";
                      if(item.faplxdm=="004"){
                          yfpdm="0000000000";
                          yfphm="00000000";
                      }else if (item.faplxdm=="028"){
                          yfpdm="000000000000";
                          yfphm="00000000";
                      }
                  }else if(item.shenqly==='1'){
                    isgffp=1;
                    hzxxbsqf=1;
                    reqmemo="N1";
                  }else if(item.shenqly==='2'){
                    isgffp=0;
                    hzxxbsqf=0;
                    reqmemo="N5";
                  }
                  let row = {
                    kpsj: item.tiankrq!= null && item.tiankrq != "" ?item.tiankrq.substring(0, 4) + "年" + item.tiankrq.substring(4, 6) + "月" + item.tiankrq.substring(6, 8) + "日" : "",
                    tzdbh: item.xinxbbh,
                    xfmc: item.xiaofmc,
                    xfsh: item.xiaofsbh,
                    gfmc: item.goufmc,
                    gfsh: item.goufsbh,
                    fpmx: details,
                    hjje: item.hejje,
                    hjse: item.hejse,
                    yfpdm: yfpdm,
                    yfphm: yfphm,
                    fpzls: item.faplxdm,
                    isgffp:isgffp,
                    hzxxbsqf:hzxxbsqf,
                    reqmemo:reqmemo
                  }
                  data.push(row);
                })
                let sendData = {cmd:"sendcmd",moduledll: "InvoiceSvrDll.dll",senddata: {cmd: "printRedInfoTable",data:data}};
                let wsurl = 'ws://127.0.0.1:50926/SysSvr';
                let ws = new WebSocket(wsurl);
                console.info('ws connect');
                ws.onopen = function () {
                    ws.send(JSON.stringify(sendData));
                };
                ws.onmessage = function (evt) {
                    console.info('ws.onmessage');
                    let msg = JSON.parse(evt.data);
                    console.log('ws message' + msg);
                }
                // ws.close();
            },
          //添加发票关联功能 state
          //打开界面查询功能
          submitSearch() {
            this.pagination.pageNum = 1
            this.getDocList()
          },
          sizechange(e) {
            this.pagination.pageSize = e
            this.getDocList()
          },
          currentChange(e) {
            this.pagination.pageNum = e
            this.getDocList()
          },
          getDocList(){
            let newSearchlist = JSON.parse(JSON.stringify(this.searchdata))
            if (this.notemptyandnull(newSearchlist.kaiprq.length)) {
              newSearchlist.docStartDate = newSearchlist.kaiprq[0]
              newSearchlist.docEndDate = newSearchlist.kaiprq[1]
            }
            delete newSearchlist.kaiprq
            let params = {
              search: newSearchlist,
              page: this.pagination.pageNum,
              limit: this.pagination.pageSize,
              sort: this.sort,
              order: this.order
            }
            this.$https.fetchPost('/redLetter/getDocListByAssociation', params).then(res => {
              this.docTableData = res.data.data
              this.pagination.total = res.data.count
            });
          },
          openDocdialog(index, row){
            this.pagination={
              pageNum: 1,
              pageSize: 10,
              total: 0
            };
            this.searchdata={
              gouhfmc:row.goufmc,
              gouhfsbh:row.goufsbh,
              fapdm:"",
              faphm:"",
              kaiprq:[],
              hejje:"",
              hejse:""
            }
            this.select_invoice_association_row=JSON.parse(JSON.stringify(row));
            this.dialogVisible_invoice_association=true;
            this.submitSearch();
          },
          submitDocAssociation(){
            var docList=this.$refs.docTableData.getSelectionval();
            console.log(docList);
            if(docList.length==0){
              this.$message({type: 'warning', message: '请选择要操作的数据'});
              return;
            }
            if(docList.length>1){
              this.$message({type: 'warning', message: '只能关联一条蓝票数据。'});
              return;
            }
            let params = {
              xinxbbh:this.select_invoice_association_row.xinxbbh,
              redLetterInfoId:this.select_invoice_association_row.id,
              docId:docList[0].id
            }
            this.$https.fetchPost('/redLetter/updateRedLetterInfoByDoc', params).then(res => {
              if (res.data.success) {
                this.dialogVisible_invoice_association = false;
                this.getRedLetterInfoList();
              }
            });
          },  setSelectKey(obj) {
            let pArr = Object.keys(obj).map(key => ({
              value: key,
              label: obj[key]
            }));
            return pArr;
          },
            //同步
            submitSktb(){

                let params = {};
                if(this.tbxxdchooseheadindex == 0){
                    if (this.tbxxdform_0.jqbh == "") {
                        this.$message.warning("请选择税盘编号");
                        return;
                    }
                    if (this.tbxxdform_0.fplxdm == "") {
                        this.$message.warning("请选择发票类型");
                        return;
                    }
                    if (this.tbxxdform_0.xxbbh == "") {
                        this.$message.warning("请输入红字信息表编号");
                        return;
                    }
                    params = Object.assign({},this.tbxxdform_0, {type:"1"});
                } else {
                    if (this.tbxxdform_1.jqbh == "") {
                        this.$message.warning("请选择税盘编号");
                        return;
                    }
                    if (this.tbxxdform_1.fplxdm == "") {
                        this.$message.warning("请选择发票类型");
                        return;
                    }
                    if (this.tbxxdform_1.tkrq == "") {
                        this.$message.warning("请选择开票日期");
                        return;
                    }
                    params = Object.assign({},this.tbxxdform_1, {type:"2",tkrqq:this.tbxxdform_1.tkrq[0],tkrqz:this.tbxxdform_1.tkrq[1]});
                }
                this.$https.fetchPost('/redLetter/syncRedLetterByHzxxb', params).then(res => {
                  if (res.data.success) {
                      this.$message.success("同步成功,请稍后...");
                      this.tbxxdclose();
                      this.resetSktb();
                    this.getRedLetterInfoList();
                  } else {
                      this.$message.error(res.data.message);
                  }
                });
            },
            //重置
            resetSktb(){
              if (this.tbxxdchooseheadindex == 0) {
                  this.tbxxdform_0.jqbh = "";
                  this.tbxxdform_0.fplxdm = "";
                  this.tbxxdform_0.xxbbh = "";
              } else {
                  this.tbxxdform_1.jqbh = "";
                  this.tbxxdform_1.fplxdm = "";
                  this.tbxxdform_1.tkrq = "";
              }
            },
            //关闭
            tbxxdclose(){
                this.tbxxddialog = false;
                this.tbxxdform_0.jqbh = "";
                this.tbxxdform_0.fplxdm = "";
                this.tbxxdform_0.xxbbh = "";
                this.tbxxdform_1.jqbh = "";
                this.tbxxdform_1.fplxdm = "";
                this.tbxxdform_1.tkrq = "";
            },
            multiply(arg1,arg2){
                if (arg1 == undefined || arg1 == "NaN") {
                    arg1 = 0
                }
                if (arg2 == undefined || arg2 == "NaN") {
                    arg2 = 0
                }
                var m=0,s1=arg1.toString().replaceAll(",",""),s2=arg2.toString().replaceAll(",","");
                try{m+=s1.split(".")[1].length}catch(e){}
                try{m+=s2.split(".")[1].length}catch(e){}
                return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
            } ,
            //除法计算
            numdiv(arg1,arg2){
                if (arg1 == undefined || arg1 == "NaN") {
                    arg1 = 0
                }
                if (arg2 == undefined || arg2 == "NaN") {
                    arg2 = 0
                }
                var t1=0,t2=0,r1,r2;
                try{t1=arg1.toString().replaceAll(",","").split(".")[1].length}catch(e){}
                try{t2=arg2.toString().replaceAll(",","").split(".")[1].length}catch(e){}
                //with(Math){
                r1=Number(arg1.toString().replace(".",""))
                r2=Number(arg2.toString().replace(".",""))
                return (r1/r2)*Math.pow(10,t2-t1);
                //}
            },

            },


          //添加发票关联功能 end

    }
</script>

<style scoped="scoped" lang="less">
    .tableallstyle {
        display: flex;
        justify-content: flex-end;
        margin-right: 10px;
        font-size: 12px;
        margin-top: 15px;
        font-weight: bold;
        color: #2F66FC;

    }

    /deep/ .el-dialog__wrapper {
        display: flex;
        align-items: center;
    }

    .keytext {
        font-size: 14px;
        font-weight: 400;
        margin-right: 15px;
        color: #333333;
    }

    .diagtitle {
        font-size: 15px;
        font-weight: 400;
        color: #2f66fc;
        margin-top: 23px;
        margin-bottom: 8px;
    }

    .forfinishsuceess :extend(.horizontally) {
        font-size: 21px;
        font-weight: 400;
        color: #2F66FC;
        margin-top: 11px;

    }

    .kuangall:extend(.distribution) {
        padding-top: 30px;
        margin-left: 48px;
    }

    .kuangall-1 {
        font-size: 14px;
        font-weight: 400;
        color: #2f66fc;
    }

    .kuangall-1 > span {
        margin-right: 83px;
    }

    .lineall {
        width: 39px;
        height: 3px;
        border-radius: 2px;
        margin-top: 8px;
    }

    .Centerhorizontally > div:extend(.Verticalcenter-line) {
        margin-right: 22.5px;
        margin-left: 22.5px;
        cursor: pointer;
    }

    // /deep/ .el-dialog__body {
    //     padding: 0;
    // }

    /deep/ .el-table--small td {
        padding: 4px 0;
    }

    /deep/ .el-table__body-wrapper {
        min-height: 160px;
    }

    .kuangall /deep/ .el-table__body-wrapper {
        min-height: 0px;
    }

    .areatable {
        margin-top: 16px;
    }

    .aftericon:extend(.Centerhorizontally) {
        width: 36px;
        height: 33px;
        background: #ffffff;
        box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.09);
        opacity: 1;
        border-radius: 3px;
        margin-left: 20px;
    }

    .aftericon > img {
        width: 16px;
        height: 16px;
    }

    .areacontent { margin-top: 16px;
        margin-left: 21px;
    }
</style>
